// extracted by mini-css-extract-plugin
export default {"container":"ScriptTab_container__9ikfz","tab":"ScriptTab_tab__6u-qg","closed":"ScriptTab_closed__+qhSK","wrapper":"ScriptTab_wrapper__MKqk9"};